import { db } from '../../../firebase'

const actions = {
    async fetchNotificationsQuery({ commit }, userID) {
        try {
            await db
                .collection('notifications')
                .orderBy('timestamp', 'desc')
                .where('recipients', 'array-contains', userID)
                .limit(10)
                .onSnapshot(snapshot => {
                    var notifications = snapshot.docs
                    .map(doc => {
                        return {
                            id: doc.id,
                            ...doc.data()
                        }
                    })

                    for(var notification of notifications) {
                        (async () => {
                            var userRef = await db
                                .collection('users')
                                .doc(notification.createdBy)
                                .get()
                        
                            notification.createdBy = {
                                id: userRef.id,
                                ...userRef.data()
                            }
                        })()
                    }

                    commit('setNotifications', notifications)

                    return () => cleanUp()
            })
        } catch(error) {
            throw error
        }
    },


    async fetchNotifications({ commit }, userID) {
        try {
            var notificationsRef = await db
                .collection('notifications')
                .orderBy('timestamp', 'desc')
                .where('recipients', 'array-contains', userID)
                .limit(10)
                .get()

            var notifications = notificationsRef.docs.map(notification => ({
                id: notification.id,
                ...notification.data()
            }))

            for(var notification of notifications) {
                var userRef = await db
                    .collection('users')
                    .doc(notification.createdBy)
                    .get()
            
                notification.createdBy = {
                    id: userRef.id,
                    ...userRef.data()
                }
            }

            commit('setNotifications', notifications)
        } catch(error) {
            throw error
        }
    },


    async createNotification({ commit }, { notification }) {
        try {
            await db
                .collection('notifications')
                .doc()
                .set(notification)
        } catch(error) {
            throw error
        }
    },



    async updateLastSeenNotification({ commit }, { userID, lastSeen }) {
        try {
            await db
                .collection('users')
                .doc(userID)
                .update({
                    'activity.lastSeenNotification': lastSeen
                })
        } catch(error) {
            throw error
        }
    },


    async deleteNotification({ commit }, id) {
        try {
            await db
                .collection('notifications')
                .doc(id)
                .delete()
        } catch(error) {
            throw error
        }
    }
}

export default actions